// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".common-cls1__c6ac231d349c17145fd1{/*!*/}.common-cls2___3217b246d6f43497963{text-align:left;font-size:20px;font-weight:500;line-height:28px;padding:0 14px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "common-cls1__c6ac231d349c17145fd1",
	"cls2": "common-cls2___3217b246d6f43497963 common-cls1__c6ac231d349c17145fd1"
};
export default ___CSS_LOADER_EXPORT___;
